import React        from "react"
import Base         from "./base"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Components
import Combobox     from "@shared/combobox"

// Helpers
import { getRequest } from '@helpers/javascript/javascript'

export default class Client extends Base {

  onChange(clients) {
    const { quote, replaceQuote } = this.props
    this.deactivate()

    getRequest(`/quotes/form/${clients}/client.json`)
      .then(async client => {
        const contact = {}
        const discount = client.discount || 0
        const reminders_enabled = client.quote_reminders_enabled_by_default
        const site = client.sites.length == 1
          ? await getRequest(`/quotes/form/${client.sites[0].id}/site.json`)
          : {}
        const vat_rate = site.vat_rate
        quote.qlines.forEach(qline => {
          if (vat_rate)     qline.vat_rate = vat_rate
          if (discount > 0) qline.discount = discount
        })
        // The site changes with the client, and equipment belongs to a site.
        replaceQuote({...quote, client, site, contact, reminders_enabled, materials: []})
      })
  }

  render() {
    const quote = this.props.quote
    const client = quote.client

    return(
      this.state.active || client.id === null
      ? <div className="form-group">
          <label>{I18n.t("workorders.client")}</label>

          <Combobox
            fieldName        = "quote[client_id]"
            identifier      = "id"
            feed            = {client.autocomplete_path}
            onSelectElement = {client => this.onChange(client.id)}
            placeholder     = {I18n.t("workorders.minimum_2_characters")}
            className       = "quotes--form-client-input"
            value           = {client.id ? client : ''}
            required 
          />

          { client.id
            ? <div onClick={this.deactivate} className = "quotes--form-client-reset">
                &times;
              </div>
            : ""
          }
        </div>
      : <>
          <div className="quotes--form-pointer no-margins" onClick={this.activate}>
            <strong>{client.name}</strong>
            <p>{client.address_1}</p>
            <p>{client.address_2}</p>
            <input type="hidden" name="quote[client_id]" defaultValue={quote.client.id} />
          </div>

          { client.unpaid_invoices &&
            <div className="client-details">
              <a  href={client.unpaid_invoices.path}
                  target="_blank"
                  className="color-open"
              >
                {
                  I18n.t("client.unpaid_invoices", {
                    number: client.unpaid_invoices.size
                  })
                }
                &nbsp;
                <FontAwesomeIcon icon="external-link-alt" />
              </a>
            </div>
          }

          { client.modal_url &&
            <div className="client-details">
              <div
                data-toggle = "modal"
                data-target = "#template-modal"
                data-route  = {client.modal_url}
                data-action = "click->client--modal#show"
                className   = "pointer button-link"
              >
                { I18n.t("client.folder") }
              </div>
            </div>
          }
        </>
    )
  }
}
